import { DiceRollResults } from "../Data/Response";
import styles from './NarrativeEventDiceRollView.module.scss';


interface NarrativeEventDiceRollViewArgs {
    results: DiceRollResults;
}

const NarrativeEventDiceRollView: React.FC<NarrativeEventDiceRollViewArgs> = args => {
    return <div className={styles.results}>
        <ul className={styles.standard}>
            {args.results.standardDice.map(r => {
                return <li className={r.success ? styles.success : ""}>{r.roll}</li>
            })}
        </ul>
        <ul className={styles.luck}>
            {args.results.luckDice.map(r => {
                return <li className={r.success ? styles.success : ""}>{r.roll}</li>
            })}
        </ul>
    </div>
}

export default NarrativeEventDiceRollView;